import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const antispoofingState = atom<boolean>({
  key: 'antispoofingState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
